<template>
  <div>
    <div>
      <h3 style="display: inline-block">Micro-credential Transfer Search</h3>
    </div>

    <form
      v-bind:class="{
        'o-form': true,
      }"
    >
      <fieldset class="o-form__section s-content-block s-content-block--small">
        <div>
          <div v-html="searchHeaderContent"></div>
          <br />
        </div>

        <!-- Course Search -->
        <div class="m-field-group m-field-group--contain search-input">
          <input
            id="course_search_input"
            type="text"
            v-model="filter.searchText"
            maxlength="10"
            @input="trimInput"
            @keydown.enter.prevent="submitSearch"
          />
          <span
            v-if="filter.searchText"
            class="fa fa-close search-input__clear"
            @click="clearSearchText"
          ></span>
        </div>

        <button type="button" class="a-button search-button" @click="submitSearch">Search</button>
      </fieldset>
    </form>

    <div
      class="cell medium-12 large-9 small-order-1 large-order-2 o-search-result"
      v-if="searchResponse.micro != null"
    >
      <div class="o-search-results">
        <div class="s-content-block s-content-block--small">
          <div class="o-search-result__table-total-page">
            <div class="medium-text-left">
              <p v-if="totalPages <= 1">
                {{ totalAgreements }} micro-credential {{ opportunityText }} found.
              </p>
              <p v-else>
                {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} micro-credential
                {{ opportunityText }} found. <br />
              </p>
            </div>

            <div
              class="o-search-results__button medium-text-right"
              v-if="searchResponse && searchResponse.micro !== null"
            >
              <form id="save-to-pdf-form" target="_blank" method="POST">
                <button
                  type="button"
                  class="a-button a-button--small a-button--primary-outline"
                  @click.prevent="downloadPdf"
                >
                  Save to PDF
                </button>
              </form>
            </div>
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
          <div class="o-search-results__table-wrapper">
            <div
              class="o-search-results__table"
              v-if="searchResponse.micro != null && _.get(searchResponse, 'micro.length') > 0"
            >
              <!-- Headings -->
              <div class="o-search-results__table-header">
                <div class="grid-x">
                  <div class="cell small-3"><strong>Micro-credential</strong></div>
                  <div class="cell small-2"><strong>To</strong></div>
                  <div class="cell small-2"><strong>Opportunity</strong></div>
                  <div class="cell small-2"><strong>Courses</strong></div>
                  <div class="cell small-1"><strong>Credits</strong></div>
                  <div class="cell small-2"><strong>Effective Dates</strong></div>
                </div>
              </div>

              <div class="o-search-results__table-row international-baccalaureate">
                <div
                  class="grid-x"
                  v-for="micro in searchResponse.micro"
                  :key="micro.MicroCredentialAssessmentGuid"
                >
                  <!-- AP Course -->
                  <div class="cell small-3">
                    <div>{{ micro.microCredentialName }}</div>
                    <div>{{ micro.partnerName }}</div>
                  </div>

                  <!-- To -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <div class="o-search-results__logo recv" :data-tooltip="micro.psiName">
                        <img :src="`${logosUrl}/${micro.globalInstitutionId}_icon.png`" />
                      </div>
                      <span>{{ micro.psiCode }}</span>
                    </div>
                  </div>

                  <!-- Opportunity -->
                  <div class="cell small-2">
                    <div>{{ micro.opportunityName }}</div>
                    <div>{{ micro.psiName }}</div>
                  </div>

                  <!-- Courses -->
                  <div class="cell small-2">
                    {{ micro.assessmentCourses }}
                  </div>

                  <!-- Credits -->
                  <div class="cell small-1">{{ micro.credit }}</div>

                  <!-- Academic Year -->
                  <div class="cell small-2">{{ micro.startDate }} - {{ micro.endDate }}</div>
                </div>
              </div>
            </div>

            <h6 v-else-if="_.get(searchResponse, 'micro.length') == 0">
              There are no micro-credential {{ opportunityText }} for that search. Please try again.
            </h6>
          </div>
          <div class="o-search-result__table-page">
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed } from 'vue'
import { defineProps, defineEmits, defineExpose } from 'vue'
import axios from 'axios'
import _ from 'lodash'

const props = defineProps({
  nonce: { type: String, required: true },
  basePagePath: { type: String, default: false },
  searchHeaderContent: { type: String, required: true },
  logosUrl: { type: String, required: true },
})

const filter = reactive({
  searchText: '',
})

const searchRequestCancelToken = ref(null)
const searchResponse = reactive({
  micro: null,
})
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = reactive({})

const opportunityText = computed(() => {
  return totalAgreements.value > 1 ? 'opportunities' : 'opportunity'
})

const trimInput = (event) => {
  filter.searchText = sanitizeInput(event.target.value)
}

const clearSearchText = () => {
  filter.searchText = ''
  submitSearch()
}

const sanitizeInput = (input) => {
  return input.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, (char) => {
    switch (char) {
      case '\0':
        return '\\0'
      case '\x08':
        return '\\b'
      case '\x09':
        return '\\t'
      case '\x1a':
        return '\\z'
      case '\n':
        return '\\n'
      case '\r':
        return '\\r'
      case '"':
      case "'":
      case '\\':
      case '%':
        return '\\' + char
    }
  })
}

const submitSearch = async () => {
  currentFilterData.searchText = filter.searchText
  searchRequestHandler('/wp-json/bctg-search/micro-credentials/agreements', currentFilterData)
}

const searchRequestHandler = (path, params) => {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }

  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.micro = null

  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')

  axios
    .post(`${path}?_wpnonce=${props.nonce}`, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => searchResponseHandler(response))
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse, response.data)
  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

const downloadPdf = (event) => {
  event.preventDefault()

  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `/wp-json/bctg-search/micro-credentials/agreements/pdf?_wpnonce=${props.nonce}`

  const newInput = document.createElement('input')
  newInput.type = 'hidden'
  newInput.id = 'searchText'
  newInput.name = 'searchText'
  newInput.value = currentFilterData.searchText || ''

  saveToPdfFormElement.append(newInput)

  saveToPdfFormElement.submit()

  saveToPdfFormElement.removeChild(newInput)
}

const newSearch = () => {
  window.location.href = props.basePagePath
}

onMounted(() => {
  submitSearch()
})
</script>

<style scoped>
.search-input {
  display: inline-block;
  position: relative;
  width: 75%;
}

.search-input input {
  padding-right: 30px;
}

.search-input__clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
}

.search-button {
  margin-left: 20px;
}

.medium-text-left p {
  margin-bottom: 1rem !important;
}

@media only screen and (max-width: 767px) {
  .search-input {
    width: 100%;
  }

  .search-button {
    margin-left: 0;
  }
}
</style>
